// extracted by mini-css-extract-plugin
export var closeButton = "_jl-1";
export var closeX = "_jl-3";
export var container = "_jl-0";
export var image = "_jl-2";